<template>
  <div>
    <div class="loading-return-rates-modal-container" :class="[open ? 'open' : 'closed']">
      <h1>Checking return services</h1>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: ["open"],
};
</script>
<style scoped>
.open {
  opacity: 1;
  top: 50%;
  transition: 0.3s ease-in-out;
}

.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.loading-return-rates-modal-container {
  position: fixed;
  z-index: 3;
  left: 50%;
  width: 660px;
  text-align: center;
  background: white;
  margin-left: -330px;
  border-radius: 20px;
  margin-top: -250px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

h1 {
  padding: 1rem;
  margin: 0;
  background: lightgrey;
  border-bottom: 1px solid black;
}
</style>
